import { request } from 'Apiv2/handleRequest';

const registrationApi = async (endpointUrl, body) => {
  try {
    const response = await request(endpointUrl, 'POST', body);
    const status = response.status;
    const { error, data } = await response.json();

    return { status, error, data };
  } catch (error) {
    return { status: 500, error };
  }
};

export default registrationApi;
